import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

const INTERVALO_MS = 5 * 60 * 1000;
const PATRON_BUNDLE = /static\/js\/main\.[a-z0-9]+\.chunk\.js/;

// Versión cargada: el nombre del bundle principal lleva el hash del build. En desarrollo
// (npm start) no hay hash y la revisión no se activa.
const versionCargada = () => {
  const script = [...document.scripts].find(s => PATRON_BUNDLE.test(s.src));
  return script ? script.src.match(PATRON_BUNDLE)[0] : null;
};

const versionPublicada = async () => {
  const resp = await fetch(`${process.env.PUBLIC_URL}/index.html?v=${Date.now()}`, { cache: 'no-store' });
  if (!resp.ok) return null;
  const html = await resp.text();
  const encontrada = html.match(PATRON_BUNDLE);
  return encontrada ? encontrada[0] : null;
};

// La app se descarga una vez al abrir la pestaña; quien la deja abierta seguía con la versión vieja
// después de un despliegue. Revisa cada 5 minutos y al volver a la pestaña: en el inicio de sesión
// recarga sola (no hay nada que perder); en el resto avisa, para no perder un formulario a medio llenar.
const UpdateChecker = () => {
  const [hayVersionNueva, setHayVersionNueva] = useState(false);

  useEffect(() => {
    const actual = versionCargada();
    if (!actual) return;

    const revisar = async () => {
      try {
        const publicada = await versionPublicada();
        if (!publicada || publicada === actual) return;
        if (window.location.pathname.includes('/authentication/')) {
          window.location.reload();
          return;
        }
        setHayVersionNueva(true);
      } catch (e) {
        // sin conexión o servidor caído: se vuelve a intentar en la próxima revisión
      }
    };

    const alVolver = () => document.visibilityState === 'visible' && revisar();
    const id = setInterval(revisar, INTERVALO_MS);
    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('focus', revisar);
    revisar();
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', alVolver);
      window.removeEventListener('focus', revisar);
    };
  }, []);

  if (!hayVersionNueva) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="d-flex align-items-center shadow rounded bg-white border px-3 py-2"
      style={{ position: 'fixed', bottom: 16, left: '50%', transform: 'translateX(-50%)', zIndex: 2000, gap: 12, maxWidth: 'calc(100% - 32px)' }}
    >
      <span className="fs--1">Hay una nueva versión de la aplicación. Guarde lo que esté haciendo y pulse Actualizar.</span>
      <Button color="primary" size="sm" onClick={() => window.location.reload()}>Actualizar</Button>
    </div>
  );
};

export default UpdateChecker;
